import React from 'react'
import { TRouteName } from 'AppTypes'

const ManagerList = React.lazy(() => import('@features/manager-management/ManagerList'))
const ManagerDetails = React.lazy(() => import('@features/manager-management/ManagerDetails'))
const StoreList = React.lazy(() => import('@features/store-management/StoreList'))
const StoreDetails = React.lazy(() => import('@features/store-management/StoreDetails'))
const StoreManager = React.lazy(() => import('@features/store-manager/storeManager'))
const ArticleList = React.lazy(() => import('@features/article-management/ArticleList'))
const ArticleDetails = React.lazy(() => import('@features/article-management/ArticleDetails'))
const AdministratorList = React.lazy(() => import('@features/administrator-management/AdministratorList'))
const AdministratorDetails = React.lazy(() => import('@features/administrator-management/AdministratorDetails'))
const AdministratorNew = React.lazy(() => import('@features/administrator-management/AdministratorNew'))
const UserList = React.lazy(() => import('@features/user-management/UserList'))
const UserDetails = React.lazy(() => import('@features/user-management/UserDetails'))
const AnimeSubscriptionList = React.lazy(() => import('@features/anime-subscription-management/AnimeSubscriptionList'))
const AnimeSubscriptionDetails = React.lazy(() => import('@features/anime-subscription-management/AnimeSubscriptionDetails'))
const AnimeSubscriptionCreate = React.lazy(() => import('@features/anime-subscription-management/AnimeSubscriptionCreate'))
const Sales = React.lazy(() => import('@features/sales-management/Sales'))
const SalesLiver = React.lazy(() => import('@features/sales-liver-management/SalesLiver'))
const ChargeManagement = React.lazy(() => import('@features/charge-management'))
const GmtsManagerDetail = React.lazy(() => import('@features/gmts-manager/gmtsManagerDetail'))
const GmtsManagerList = React.lazy(() => import('@features/gmts-manager/gmtsManagerList'))
const AffiliateList = React.lazy(() => import('@features/affiliate-management/AffiliateList'))
const AffiliateDetails = React.lazy(() => import('@features/affiliate-management/AffiliateDetails'))
const VideoReport = React.lazy(() => import('@features/video-report/VideoReport'))
const UserPoints = React.lazy(() => import('@features/user-management/UserPoints'))
const StoreRecommendation = React.lazy(() => import('@features/store-recommendation/StoreRecommendation'))
const RecommendationList = React.lazy(() => import('@features/store-recommendation/RecommendationList'))
const CustomerQuestion = React.lazy(() => import('@features/customer-question/CustomerQuestion'))
const Marks = React.lazy(() => import('@features/marks/Marks'))
const MarkDetails = React.lazy(() => import('@features/marks/MarkDetails'))
const StoreMarks = React.lazy(() => import('@features/store-marks/StoreMarks'))
const StoreMarksDetails = React.lazy(() => import('@features/store-marks/StoreMarksDetails'))
const NotificationList = React.lazy(() => import('@features/notification-management/NotificationList'))
const InvoiceList = React.lazy(() => import('@features/invoice-management/InvoiceList'))
const OPTIntroductionVideoServiceList = React.lazy(() => import('@features/opt/IntroductionVideo/OPTIntroductionVideoServiceList'))
const OPTIntroductionVideoServiceDetail = React.lazy(() => import('@features/opt/IntroductionVideo/OPTIntroductionVideoServiceDetail'))
const AmbassadorList = React.lazy(() => import('@features/ambassador-management/AmbassadorList'))
const OPTInitialSetupServiceList = React.lazy(() => import('@features/opt/InitialSetup/OPTInitialSetupServiceList'))
const OPTInitialSetupServiceDetail = React.lazy(() => import('@features/opt/InitialSetup/OPTInitialSetupServiceDetail'))
const UserProfile = React.lazy(() => import('@features/userprofile/UserProfile'))
const WebNotificationList = React.lazy(() => import('@features/webnotification-management/WebNotificationList'))
const WebNotificationUpsert = React.lazy(() => import('@features/webnotification-management/WebNotificationUpsert'))
const LiverVideoPointPerPeriodSetting = React.lazy(() => import('@features/setting-management/LiverVideoPointPerPeriodSetting'))
const BannerNotificationUpsert = React.lazy(() => import('@features/bannerNotification-management/BannerNotificationUpsert'))
const BannerNotificationList = React.lazy(() => import('@features/bannerNotification-management/BannerNotificationList'))
const NotificationUpsert = React.lazy(() => import('@features/notification-management/NotificationUpsert'))
const TopAppBannerList = React.lazy(() => import('@features/appBanner-management/TopBanner/TopAppBannerList'))
const TopAppBannerUpsert = React.lazy(() => import('@features/appBanner-management/TopBanner/TopAppBannerUpsert'))
const BottomAppBannerList = React.lazy(() => import('@features/appBanner-management/BottomBanner/BottomAppBannerList'))
const BottomAppBannerUpsert = React.lazy(() => import('@features/appBanner-management/BottomBanner/BottomAppBannerUpsert'))
const PageSetupList = React.lazy(() => import('@features/pageSetup-management/PageSetupList'))
const FixedScreenUpsert = React.lazy(() => import('@features/pageSetup-management/FixedScreenUpsert'))
const UserListUpsert = React.lazy(() => import('@features/pageSetup-management/UserListUpsert'))
const LiversVideoList = React.lazy(() => import('@features/pageSetup-management/LiversVideoList'))
const ListGMBCharge = React.lazy(() => import('@features/charge-management/ListGMBCharge'))

export const ROUTES: { path: TRouteName, component: React.ComponentType<any> }[] = [
  { path: '/affiliate-list', component: AffiliateList },
  { path: '/affiliate-details', component: AffiliateDetails },
  { path: '/store-manager', component: StoreManager },
  { path: '/store-list', component: StoreList },
  { path: '/store-approval', component: StoreList },
  { path: '/store-details', component: StoreDetails },
  { path: '/manager-list', component: ManagerList },
  { path: '/manager-details', component: ManagerDetails },
  { path: '/article-list', component: ArticleList },
  { path: '/article-details', component: ArticleDetails },
  { path: '/administrator-list', component: AdministratorList },
  { path: '/administrator-details', component: AdministratorDetails },
  { path: '/administrator-new', component: AdministratorNew },
  { path: '/user-list', component: UserList },
  { path: '/user-details', component: UserDetails },
  { path: '/user-points', component: UserPoints },
  { path: '/support-video', component: VideoReport },
  { path: '/video-premium-list', component: AnimeSubscriptionList },
  { path: '/video-premium-details', component: AnimeSubscriptionDetails },
  { path: '/video-premium-create', component: AnimeSubscriptionCreate },
  { path: '/sales-management', component: Sales },
  { path: '/sales-liver', component: SalesLiver },
  { path: '/charge-management', component: ChargeManagement },
  { path: '/invoice-management', component: InvoiceList },
  { path: '/gmts-manager-list', component: GmtsManagerList },
  { path: '/gmts-manager-detail', component: GmtsManagerDetail },
  { path: '/store-recommendation', component: StoreRecommendation },
  { path: '/recommendations', component: RecommendationList },
  { path: '/user-question', component: CustomerQuestion },
  { path: '/marks', component: Marks },
  { path: '/mark-details', component: MarkDetails },
  { path: '/store-marks', component: StoreMarks },
  { path: '/store-marks-details', component: StoreMarksDetails },
  { path: '/notification-list', component: NotificationList },
  { path: '/notification-upsert', component: NotificationUpsert },
  { path: '/webnotification-list', component: WebNotificationList },
  { path: '/webnotification-upsert', component: WebNotificationUpsert },
  { path: '/introductionvideoservice-management', component: OPTIntroductionVideoServiceList },
  { path: '/introductionvideoservice-detail', component: OPTIntroductionVideoServiceDetail },
  { path: '/ambassador-list', component: AmbassadorList },
  { path: '/initialsetupservice-management', component: OPTInitialSetupServiceList },
  { path: '/initialsetupservice-detail', component: OPTInitialSetupServiceDetail },
  { path: '/user-profile', component: UserProfile },
  { path: '/livervideo-pointperperiod-setting', component: LiverVideoPointPerPeriodSetting },
  { path: '/bannernotification-upsert', component: BannerNotificationUpsert },
  { path: '/bannernotification-list', component: BannerNotificationList },
  { path: '/topappbanner-list', component: TopAppBannerList },
  { path: '/bannernotification-upsert', component: BannerNotificationList },
  { path: '/topappbanner-upsert', component: TopAppBannerUpsert },
  { path: '/bottomappbanner-list', component: BottomAppBannerList },
  { path: '/bottomappbanner-upsert', component: BottomAppBannerUpsert },
  { path: '/pagesetup-list', component: PageSetupList },
  { path: '/pagesetup/fixedscreen', component: FixedScreenUpsert },
  { path: '/pagesetup/userlist', component: UserListUpsert },
  { path: '/pagesetup/liversvideolist', component: LiversVideoList },
  { path: '/gmbchargeList', component: ListGMBCharge },
  { path: '/', component: StoreList }
]
